/**
 * RUL Login Example Page
 *
 * UPDATED: Now using UniversalRULForm with REAL backend!
 *
 * This page demonstrates 100% backend-driven forms:
 * - Backend defines form at: GET /v2/api/formsexamples/rul/forms/login
 * - Frontend just renders with ONE line: <UniversalRULForm formUrl="..." />
 * - Backend can include: logo, form fields, links, language selector, theme toggle
 *
 * Route: /apps/examples/forms/login
 * API: /v2/api/formsexamples/rul/forms/login
 */

import { useEffect } from 'react';
import { message } from 'antd';
import { useLayoutConfig } from '@/components/common/ProtectedLayout';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import './RULLoginPage.css';

export const RULLoginPage: React.FC = () => {
  const { setNoPadding } = useLayoutConfig();

  // Set noPadding mode for this page
  useEffect(() => {
    setNoPadding(true);
    return () => setNoPadding(false);
  }, [setNoPadding]);

  const handleSuccess = (data: any) => {
    message.success('Login successful!');
    console.log('Form submitted:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="rul-login-page">
      <div className="rul-login-container">
        <div className="rul-login-card">
          <UniversalRULForm
            formUrl="/formsexamples/rul/forms/login"
            onSuccess={handleSuccess}
            onError={handleError}
            className="rul-login-form"
            showSubmitButton={false}
          />
        </div>
      </div>
    </div>
  );
};
